import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as settings from "../../lib/air-api-constant";


@Injectable({
    providedIn: 'root'
})
export class AlertService {

    public alertUpdatPromise = new BehaviorSubject<string>("");
    public $alertUpdate = this.alertUpdatPromise.asObservable();

    constructor(protected http: HttpClient) { }

    updateAlertShipment(shipment: any) {
        this.alertUpdatPromise.next(shipment);
    }

    // setAlertShipment(shipmentData: any = {}) {
    //     let url = settings.UserEndPoint.Alert.ADD_ALERT;
    //     return this.http.post<any>(url, shipmentData);
    // }

    // removeAlertShipment(shipmentData: any = {}) {
    //     let url = settings.UserEndPoint.Alert.REMOVE_ALERT;
    //     return this.http.post<any>(url, shipmentData);
    // }

    //getAlertsForUser(shipmentData: any = {}) {
    //     let url = settings.UserEndPoint.Alert.GET_USER_ALERTS;
    //     return this.http.post<any>(url, shipmentData);
    // }

   // getNewAlertCount(data: any) {
    //     let url = settings.UserEndPoint.Alert.ALERT_COUNT;
    //     return this.http.post<any>(url, data);
    // }

    // getAlerts(alertLimit: any = {}) {
    //     let url = settings.UserEndPoint.Alert.GET_ALERTS;
    //     return this.http.post<any>(url, alertLimit);
    // }

    // setUserNotificationOff(userid: any = {}) {
    //     let url = settings.UserEndPoint.Alert.DE_NOTIFY;
    //     return this.http.post<any>(url, userid);
    // }

    // setUserAlertAsRead(userid: any = {}) {
    //     let url = settings.UserEndPoint.Alert.MARK_US_READ;
    //     return this.http.post<any>(url, userid);
    // }

    // getAlertsForShipment(shipmentId: any = {}) {
    //     let queryParams = new HttpParams();
    //     queryParams = queryParams.append("shipmentId", shipmentId)
    //     return this.http.get<any[]>(settings.UserEndPoint.Alert.GET_ALERTS_SHIPMENT, { params: queryParams });
    // }
    
    // readAllAlerts(body: any = {}) {
    //     let url = settings.UserEndPoint.Alert.MARK_ALL_US_READ;
    //     return this.http.post<any>(url,body);
    // }
}
